// extracted by mini-css-extract-plugin
module.exports = {"container":"FormImageOption_container__3Wfyq text_element__2vrEM","label":"FormImageOption_label__14jjR","cover":"FormImageOption_cover__3pCdC"};